<template>
    <el-dialog title="咨询反馈" :visible.sync="dialogVisible" width="600px" @close="handleClose">
        <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="80px">
            <el-form-item label="请选择您遇到的问题类型">
                <el-radio-group v-model="form.questionType">
                    <el-radio v-for="item in typeList" :label="item.value">{{ item.label }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="请选择您遇到的业务场景">
                <el-radio-group v-model="form.questionScene">
                    <el-radio v-for="item in scenList" :label="item.value">{{ item.label }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="请输入描述" prop="describe">
                <el-input type="textarea" v-model="form.describe"></el-input>
            </el-form-item>
            <el-form-item label="上传图片">
                <el-upload class="avatar-uploader" ref="upload" :limit="2" list-type="picture-card" action="#"
                    :http-request="customUpload" :on-remove="handleRemove" :on-success="handleSuccess"
                    :file-list="fileList" :auto-upload="true">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">请上传问题图片，上传的图片大小不能超过2MB</div>
                </el-upload>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="onSubmit">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { uploadFileApi, userFeedBackUp, selectFeedBackType, selectFeedbackDataByTicket } from '@/api/index'
const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substring(2, 6)
}
export default {
  name: 'AuthDialog',
  data () {
    return {
      dialogVisible: false,
      typeList: [],
      scenList: [],
      fileList: [],
      rules: {
        describe: [
          { required: true, message: '请输入描述', trigger: 'blur' }
        ]
      },
      form: {
        questionType: '', // 问题类型
        questionScene: '', // 问题场景
        describe: '', // 描述
        questionImg: ''// 上传图片
      }
    }
  },
  mounted () {
    this.loadZd()
  },
  methods: {
    async loadZd () {
      const result = await selectFeedBackType()
      this.typeList = result.data
      this.form.questionType = this.typeList[0].value // 问题类型
      const result2 = await selectFeedbackDataByTicket()
      this.scenList = result2.data
      this.form.questionScene = this.scenList[0].value
    },
    customUpload (file) {
      const formData = new FormData()
      formData.append('file', file.file) // 将文件添加到 FormData 中
      uploadFileApi(formData).then(res => {
        if (res.code == 0) {
          console.log(res)
          this.fileList.push({
            uid: generateId(),
            url: res.data
          })
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    handleSuccess () {
      console.log('============上传成功了')
      console.log(this.fileList)
    },
    async onSubmit () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            if (this.fileList.length > 0) {
              this.form.questionImg = this.fileList.map(item => item.url).join(',')
            }
            const result = await userFeedBackUp(this.form)
            if (result.code == 0) {
              this.$message.success('提交成功')
              this.dialogVisible = false
            } else {
              this.$message.error(result.msg)
            }
          } catch (error) {
            // 错误
          }
        }
      })
    },
    open () {
      this.dialogVisible = true
    },
    handleClose () {
      this.resetForm()
      this.$emit('close')
    },
    // 删除图片
    handleRemove (file, fileList) {
      this.fileList = fileList
    },
    resetForm () {
      this.$refs.form.resetFields()
      this.fileList = []
      this.form = {
        questionType: '', // 问题类型
        questionScene: '', // 问题场景
        describe: '', // 描述
        questionImg: ''// 上传图片
      }
      this.form.questionType = this.typeList[0].value // 问题类型
      this.form.questionScene = this.scenList[0].value
    }
  }
}
</script>

<style scoped></style>
